import styled from '@emotion/styled';
import { theme } from '../../constants/theme';

export const StyledFileUpload = styled.div`
  width: 100%;
`;

export const DropZone = styled.div`
  border: 2px dashed ${props => 
    props.$error ? theme.colors.error.main :
    props.$dragActive ? theme.colors.primary.main : 
    theme.colors.gray[300]
  };
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing['2xl']};
  text-align: center;
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  transition: ${theme.transitions.duration.normal} ${theme.transitions.timing.easeInOut};
  background-color: ${props => 
    props.$dragActive ? `${theme.colors.primary.light}10` : 
    props.$disabled ? theme.colors.gray[100] :
    theme.colors.background.paper
  };
  opacity: ${props => props.$disabled ? 0.6 : 1};

  &:hover {
    ${props => !props.$disabled && `
      border-color: ${theme.colors.primary.main};
      background-color: ${theme.colors.primary.light}05;
    `}
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const UploadIcon = styled.div`
  color: ${theme.colors.primary.main};
  margin-bottom: ${theme.spacing.md};
  
  svg {
    width: 3rem;
    height: 3rem;
  }
`;

export const UploadText = styled.p`
  margin: ${theme.spacing.xs} 0;
  font-size: ${theme.typography.fontSize.sm};
  color: ${props => props.$secondary ? theme.colors.text.secondary : theme.colors.text.primary};
  
  strong {
    color: ${theme.colors.primary.main};
    font-weight: ${theme.typography.fontWeight.semibold};
  }
`;

export const ErrorText = styled.div`
  margin-top: ${theme.spacing.sm};
  font-size: ${theme.typography.fontSize.xs};
  color: ${props => props.$error ? theme.colors.error.main : theme.colors.text.secondary};
`;

export const FileList = styled.div`
  margin-top: ${theme.spacing.md};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  background-color: ${theme.colors.background.alt};
  border: 1px solid ${theme.colors.gray[200]};
  border-radius: ${theme.borderRadius.sm};
  transition: ${theme.transitions.duration.fast} ${theme.transitions.timing.easeInOut};

  &:hover {
    background-color: ${theme.colors.gray[100]};
  }

  svg {
    color: ${theme.colors.primary.main};
    flex-shrink: 0;
  }

  .file-info {
    flex: 1;
    min-width: 0;
    
    .file-name {
      font-size: ${theme.typography.fontSize.sm};
      font-weight: ${theme.typography.fontWeight.medium};
      color: ${theme.colors.text.primary};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
    .file-size {
      font-size: ${theme.typography.fontSize.xs};
      color: ${theme.colors.text.secondary};
      margin-top: 2px;
    }
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.xs};
  background: none;
  border: none;
  border-radius: ${theme.borderRadius.sm};
  color: ${theme.colors.text.secondary};
  cursor: pointer;
  transition: ${theme.transitions.duration.fast} ${theme.transitions.timing.easeInOut};
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background-color: ${theme.colors.error.light}20;
    color: ${theme.colors.error.main};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
